import { useEffect, useState } from 'react';

export const useIsWindowFocused = () => {
  const [isFocused, setIsFocused] = useState(true);

  useEffect(() => {
    const handleFocus = () => setIsFocused(true);
    const handleBlur = () => setIsFocused(false);

    window.addEventListener('focus', handleFocus);
    window.addEventListener('blur', handleBlur);

    return () => {
      window.removeEventListener('focus', handleFocus);
      window.removeEventListener('blur', handleBlur);
    };
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setIsFocused(document.hasFocus());
    }, 500);

    return () => {
      clearInterval(interval);
    };
  }, []);

  return isFocused;
};
